export default {
  data() {
    return {
      canBeSubmitted: false,
    }
  },
  watch: {
    form: {
      handler() {
        this.canBeSubmitted =
          Object.values(this.form.fields).find((field) => field.valid === false) === undefined
      },
      deep: true,
    },
  },
}
